export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";